module.exports = __webpack_public_path__ + "static/media/aura-logo-medium.9e296398.svg";